import { PropsWithChildren } from "react";

const CleComplianceProvider = ({ children }: PropsWithChildren) => {
  return <div className="cle-compliance-feature">{children}</div>;
};

export default CleComplianceProvider;
